import { useEffect, useRef, useState } from "react";

import { useSearchParams } from "next/navigation";

import { convertUrlParamsToFormValues } from "../helpers";
import { SearchInputsSchema } from "../models";

export const useDefaultFormValuesFromSearchParams = () => {
  const searchParams = useSearchParams();
  const onceReturtedFlag = useRef(false);

  const [formValues, setFormValues] = useState<SearchInputsSchema | null>(null);

  useEffect(() => {
    if (onceReturtedFlag.current) return;

    const resultFormValues = convertUrlParamsToFormValues(searchParams);

    setFormValues(resultFormValues);
    onceReturtedFlag.current = true;
  }, [searchParams]);

  return formValues;
};
